import React, { useEffect, useState, useCallback, useMemo } from "react";
import { UPLOADS } from "../../config/api";
import "./mybids.css";
import DateFilter from "../../Admin/Pages/DateFilter";
import { API } from "../../config/api";
import { useNavigate } from "react-router-dom";
export default function MyBids() {
  const BASE_URL = `${API.BASE_URL}/api.php`;
  const BASE_URL1 = `${API.BASE_URL}/payment.php`;
  const navigate = useNavigate();

  const user = JSON.parse(sessionStorage.getItem("user"));

  // Default fallback status list
  const DEFAULT_STATUS_LIST = [
    "All",
    "Pending",
    "Rejected",
    "Accepted",
    "Start Work",
    "In Progress",
    "Work in Review",
    "Completed",
    "Paid",
  ];

  // --- Dynamic Navigation Tab State ---
  const [activeTab, setActiveTab] = useState("bids"); // 'bids' or 'payments'

  // --- Dynamic Status List State ---
  const [statusList, setStatusList] = useState(["All"]);
  const [showStatusModal, setShowStatusModal] = useState(false);
  const [selectedStatusBid, setSelectedStatusBid] = useState(null);
  const [showPriceModal, setShowPriceModal] = useState(false);
  const [selectedPriceBid, setSelectedPriceBid] = useState(null);
  const [designerRating, setDesignerRating] = useState(0);
  const [allWorkBids, setAllWorkBids] = useState({});
  const [designerRatingCount, setDesignerRatingCount] = useState(0);
  // --- Theme State (Light / Dark) ---
  const [theme, setTheme] = useState(
    () => localStorage.getItem("eb_theme") || "light",
  );

  const toggleTheme = () => {
    const nextTheme = theme === "light" ? "dark" : "light";
    setTheme(nextTheme);
    localStorage.setItem("eb_theme", nextTheme);
  };

  const [beads, setBeads] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSendModal, setShowSendModal] = useState(false);
  const [selectedWork, setSelectedWork] = useState(null);
  const [showDescriptionModal, setShowDescriptionModal] = useState(false);
  const [selectedDescription, setSelectedDescription] = useState("");
  const [message, setMessage] = useState("");
  const [files, setFiles] = useState([]);
  const [lightboxData, setLightboxData] = useState(null);
  const [payments, setPayments] = useState([]);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("All");
  const [selectedBid, setSelectedBid] = useState(null);
  const [priceInput, setPriceInput] = useState("");
  const [showEditModal, setShowEditModal] = useState(false);
  const [commission, setCommission] = useState(0);
  const getCommission = async () => {
    try {
      const response = await fetch(
        `${BASE_URL}?action=get_platform_bid_commission`,
      );

      const result = await response.json();

      if (result.status) {
        setCommission(Number(result.commission));
      }
    } catch (err) {
      console.error(err);
    }
  };
  useEffect(() => {
    getCommission();
  }, []);
  const openDescriptionModal = (description) => {
    setSelectedDescription(description);
    setShowDescriptionModal(true);
  };
  useEffect(() => {
    if (user?.id) {
      getStatusList();
      getMyBeads();
      getPaymentHistory();
    }
  }, []);

  const getStatusList = async () => {
    try {
      const response = await fetch(`${BASE_URL}?action=get_bid_statuses`);
      const result = await response.json();

      if (
        result.status &&
        Array.isArray(result.data) &&
        result.data.length > 0
      ) {
        const dbStatuses = result.data.map((item) =>
          typeof item === "object" ? item.status : item,
        );
        const uniqueStatuses = Array.from(new Set(["All", ...dbStatuses]));
        setStatusList(uniqueStatuses);
      } else {
        setStatusList(DEFAULT_STATUS_LIST);
      }
    } catch (err) {
      console.error("Error fetching status list:", err);
      setStatusList(DEFAULT_STATUS_LIST);
    }
  };

  const getPaymentHistory = async () => {
    try {
      const response = await fetch(
        `${BASE_URL1}?action=get_designer_payment_history&designer_id=${user.id}`,
      );

      const result = await response.json();

      if (result.status) {
        setPayments(result.data);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const filterByDate = (itemDate) => {
    if (!fromDate && !toDate) return true;

    const date = new Date(itemDate).setHours(0, 0, 0, 0);
    const from = fromDate ? new Date(fromDate).setHours(0, 0, 0, 0) : null;
    const to = toDate ? new Date(toDate).setHours(23, 59, 59, 999) : null;

    if (from && date < from) return false;
    if (to && date > to) return false;

    return true;
  };

  const filteredBeads = useMemo(() => {
    return beads.filter((item) => {
      const passesDate = filterByDate(item.created_at);
      if (!passesDate) return false;

      if (selectedStatus === "All") return true;

      const itemStatus = item.status || "";
      const isPaid = item.status === "Paid" || item.payment_status === "Paid";

      if (selectedStatus === "Paid") {
        return isPaid;
      }

      return (
        itemStatus.toLowerCase().trim() === selectedStatus.toLowerCase().trim()
      );
    });
  }, [beads, fromDate, toDate, selectedStatus]);

  const filteredPayments = useMemo(() => {
    return payments.filter((item) => filterByDate(item.payment_date));
  }, [payments, fromDate, toDate]);
  const downloadFiles = (item) => {
    let images = item.images;

    if (typeof images === "string") {
      try {
        images = JSON.parse(images);
      } catch {
        images = [];
      }
    }

    if (!Array.isArray(images) || images.length === 0) {
      alert("No files found");
      return;
    }

    images.forEach((file, index) => {
      setTimeout(() => {
        const a = document.createElement("a");
        a.href = `${API.BASE_URL}/download_work_image.php?owner=${item.owner_id}&file=${encodeURIComponent(file)}`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      }, index * 300);
    });
  };
  const editBid = (bid) => {
    setSelectedBid(bid);
    setPriceInput(bid.price);
    setShowEditModal(true);
  };
  const updateBidPrice = async (e) => {
    e.preventDefault();

    if (!priceInput || Number(priceInput) <= 0) {
      alert("Please enter valid price");
      return;
    }

    setIsSubmitting(true);

    const formData = new FormData();
    formData.append("bid_id", selectedBid.id);
    formData.append("price", priceInput);

    try {
      const response = await fetch(`${BASE_URL}?action=update_bid_price`, {
        method: "POST",
        body: formData,
      });

      const result = await response.json();

      alert(result.message);

      if (result.status) {
        setShowEditModal(false);
        setSelectedBid(null);
        getMyBeads();
      }
    } catch (err) {
      console.log(err);
      alert("Something went wrong.");
    } finally {
      setIsSubmitting(false);
    }
  };
  const cancelAcceptedBid = async (item) => {
    const confirmed = window.confirm(
      "Are you sure you want to cancel this accepted bid?",
    );

    if (!confirmed) return;

    setIsSubmitting(true);

    const formData = new FormData();
    formData.append("bid_id", item.id);
    formData.append("designer_id", user.id);

    try {
      const response = await fetch(`${BASE_URL}?action=cancel_accepted_bid`, {
        method: "POST",
        body: formData,
      });

      const result = await response.json();

      alert(result.message);

      if (result.status) {
        // Remove cancelled bid immediately from My Bids table/card
        setBeads((prev) =>
          prev.filter((bid) => Number(bid.id) !== Number(item.id)),
        );

        // Refresh payment history if required
        getPaymentHistory();
      }
    } catch (error) {
      console.error("Cancel accepted bid error:", error);
      alert("Something went wrong while cancelling the bid.");
    } finally {
      setIsSubmitting(false);
    }
  };
  const getDesignerRating = async () => {
    try {
      const response = await fetch(
        `${BASE_URL}?action=get_designer_rating&designer_id=${user.id}`,
      );

      const result = await response.json();

      if (result.status) {
        setDesignerRating(Number(result.data?.rating || 0));
        setDesignerRatingCount(Number(result.data?.rating_count || 0));
      } else {
        setDesignerRating(0);
        setDesignerRatingCount(0);
      }
    } catch (err) {
      console.error("Error fetching designer rating:", err);
      setDesignerRating(0);
      setDesignerRatingCount(0);
    }
  };
  useEffect(() => {
    if (user?.id) {
      getStatusList();
      getMyBeads();
      getPaymentHistory();

      // Always fetch rating
      getDesignerRating();
    }
  }, []);
  const stats = useMemo(() => {
    return beads.reduce(
      (acc, b) => {
        const received = parseFloat(b.received_amount || 0);
        const status = String(b.status || "").trim();

        // Consider payment paid if ANY of these indicate Paid
        const isPaid =
          status.toLowerCase() === "paid" ||
          String(b.payment_status || "").toLowerCase() === "paid" ||
          b.is_paid === 1 ||
          b.is_paid === "1" ||
          b.is_paid === true;

        acc.totalBids += 1;

        // Pending
        if (status === "Pending") {
          acc.pending += 1;
        }

        // In Progress
        if (status === "In Progress" || status === "Start Work") {
          acc.inProgress += 1;
        }

        // Completed / Paid
        if (status === "Completed" || status === "Paid") {
          acc.completed += 1;

          if (isPaid) {
            // Payment received
            acc.paidAmount += received;
            acc.paidCount += 1;
          } else {
            // Payment still pending
            acc.unpaidAmount += received;
            acc.unpaidCount += 1;
          }
        }

        return acc;
      },
      {
        totalBids: 0,
        pending: 0,
        inProgress: 0,
        completed: 0,
        paidAmount: 0,
        unpaidAmount: 0,
        paidCount: 0,
        unpaidCount: 0,
      },
    );
  }, [beads]);

  // const getMyBeads = async () => {
  //   setLoading(true);

  //   try {
  //     const response = await fetch(
  //       `${BASE_URL}?action=get_my_beads&designer_id=${user.id}`,
  //     );

  //     const result = await response.json();

  //     if (result.status) {
  //       const data = result.data || [];

  //       setBeads(data);
  //     }
  //   } catch (err) {
  //     console.error("Error fetching beads:", err);
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  const getMyBeads = async () => {
    setLoading(true);

    try {
      const response = await fetch(
        `${BASE_URL}?action=get_my_beads&designer_id=${user.id}`,
      );

      const result = await response.json();

      if (result.status) {
        const data = result.data || [];

        setBeads(data);

        // Get all bids for every work
        const workIds = [
          ...new Set(
            data.map((item) => Number(item.work_id)).filter((id) => id > 0),
          ),
        ];

        const workBidResults = await Promise.all(
          workIds.map(async (workId) => {
            const bids = await getAllBidsByWork(workId);

            return {
              workId,
              bids,
            };
          }),
        );

        const groupedBids = {};

        workBidResults.forEach(({ workId, bids }) => {
          groupedBids[workId] = bids;
        });

        setAllWorkBids(groupedBids);
      } else {
        setBeads([]);
        setAllWorkBids({});
      }
    } catch (err) {
      console.error("Error fetching beads:", err);
      setBeads([]);
      setAllWorkBids({});
    } finally {
      setLoading(false);
    }
  };
  const getAllBidsByWork = async (workId) => {
    if (!workId) return [];

    try {
      const response = await fetch(
        `${BASE_URL}?action=get_all_bids_by_work&work_id=${workId}`,
      );

      const result = await response.json();

      if (result.status && Array.isArray(result.data)) {
        return result.data;
      }

      return [];
    } catch (err) {
      console.error("Error fetching all bids:", err);
      return [];
    }
  };
  const deleteBeads = async (id) => {
    if (!window.confirm("Are you sure you want to delete this bid request?")) {
      return;
    }

    const formData = new FormData();
    formData.append("id", id);

    try {
      const response = await fetch(`${BASE_URL}?action=delete_my_beads`, {
        method: "POST",
        body: formData,
      });

      const result = await response.json();
      alert(result.message);

      if (result.status) {
        getMyBeads();
      }
    } catch (err) {
      console.error("Delete error:", err);
    }
  };

  const paymentSummary = useMemo(() => {
    const total = filteredPayments.reduce(
      (sum, p) => sum + Number(p.amount || 0),
      0,
    );

    return {
      totalPayment: total,
      totalPaid: filteredPayments.length,
    };
  }, [filteredPayments]);

  const sendCompletedWork = async () => {
    if (!files.length && !message.trim()) {
      alert("Please enter a message or attach completed work files.");
      return;
    }

    setIsSubmitting(true);
    const fd = new FormData();
    fd.append("bid_id", selectedWork.id);
    fd.append("designer_id", user.id);
    fd.append("message", message);

    files.forEach((file) => {
      fd.append("files[]", file);
    });

    try {
      const response = await fetch(`${BASE_URL1}?action=send_completed_work`, {
        method: "POST",
        body: fd,
      });
      const text = await response.text();

      let result;
      try {
        result = JSON.parse(text);
      } catch (e) {
        result = { status: true, message: "Work submitted successfully!" };
      }

      alert(result.message || "Work sent successfully!");

      setShowSendModal(false);
      setMessage("");
      setFiles([]);
      getMyBeads();
    } catch (err) {
      console.error("Error sending work:", err);
      alert("Failed to submit completed work. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const startWork = async (bidId) => {
    if (!window.confirm("Start this work?")) return;

    const formData = new FormData();
    formData.append("bid_id", bidId);

    try {
      const response = await fetch(`${BASE_URL1}?action=start_work`, {
        method: "POST",
        body: formData,
      });

      const result = await response.json();
      alert(result.message);

      if (result.status) {
        getMyBeads();
      }
    } catch (err) {
      console.error(err);
    }
  };

  const openLightbox = (imagesArray, initialIndex, ownerId) => {
    const fullUrls = imagesArray.map(
      (img) => `${UPLOADS.WORK_IMAGE}/${ownerId}/${img}`,
    );
    setLightboxData({
      images: fullUrls,
      currentIndex: initialIndex,
    });
  };

  const handlePrevImage = useCallback(() => {
    if (!lightboxData) return;
    setLightboxData((prev) => ({
      ...prev,
      currentIndex:
        prev.currentIndex === 0
          ? prev.images.length - 1
          : prev.currentIndex - 1,
    }));
  }, [lightboxData]);

  const handleNextImage = useCallback(() => {
    if (!lightboxData) return;
    setLightboxData((prev) => ({
      ...prev,
      currentIndex:
        prev.currentIndex === prev.images.length - 1
          ? 0
          : prev.currentIndex + 1,
    }));
  }, [lightboxData]);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!lightboxData) return;
      if (e.key === "ArrowLeft") handlePrevImage();
      if (e.key === "ArrowRight") handleNextImage();
      if (e.key === "Escape") setLightboxData(null);
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [lightboxData, handlePrevImage, handleNextImage]);
  const bidPrice = Number(priceInput || 0);

  const commissionAmount = (bidPrice * commission) / 100;

  const finalAmount = bidPrice - commissionAmount;

  const STATUS_STEPS = [
    "Pending",
    "Accepted",
    "Start Work",
    "In Progress",
    "Work in Review",
    "Completed",
    "Paid",
  ];

  const getStatusInfo = (status) => {
    const statusMap = {
      Pending: {
        icon: "bi-hourglass-split",
        title: "Bid Waiting for Approval",
        message:
          "Your bid has been submitted successfully. The client is currently reviewing your proposal. You can edit or delete your bid until a decision is made.",
      },

      Rejected: {
        icon: "bi-x-circle-fill",
        title: "Bid Was Not Accepted",
        message:
          "Unfortunately, this bid was not selected by the client. You can continue exploring and applying for other available work requests.",
      },

      Accepted: {
        icon: "bi-check-circle-fill",
        title: "Waiting for Admin Payment Confirmation",
        message:
          "Your bid has been accepted successfully. Please wait for the client or administrator to move the project to the Start Work stage.",
      },

      "Start Work": {
        icon: "bi-play-circle-fill",
        title: "Click Below Button to Start Work",
        message:
          "The project is now assigned to you. Review the work requirements and click Start Work when you are ready to begin.",
      },

      "In Progress": {
        icon: "bi-gear-fill",
        title: "Work Currently in Progress",
        message:
          "You are currently working on this project. Once the work is completed, upload and submit your final files for review.",
      },

      "Work in Review": {
        icon: "bi-eye-fill",
        title: "Your Work Is Being Reviewed",
        message:
          "Your completed work has been submitted successfully and is currently being reviewed. Please wait for the review result.",
      },

      Completed: {
        icon: "bi-check2-all",
        title: "Work Completed Successfully",
        message:
          "This project has been marked as completed. Payment processing will be handled according to the platform payment process.",
      },

      Paid: {
        icon: "bi-wallet2",
        title: "Payment Successfully Received",
        message:
          "Congratulations! The payment for this project has been successfully processed and added to your payment history.",
      },

      Cancelled: {
        icon: "bi-x-circle",
        title: "Work Cancelled by the client",
        message:
          "This project has been deleted by the client, so your bid has been cancelled.",
      },
    };

    return (
      statusMap[status] || {
        icon: "bi-info-circle-fill",
        title: status || "Project Status",
        message:
          "The status of this project has been updated. Please check the project details for more information.",
      }
    );
  };
  const openPriceDetails = (item) => {
    setSelectedPriceBid(item);
    setShowPriceModal(true);
  };
  const openStatusDetails = (item) => {
    setSelectedStatusBid(item);
    setShowStatusModal(true);
  };
  const getAcceptedPrice = (item) => {
    return Number(item.accepted_price || item.final_price || item.price || 0);
  };
  const getRecievedAmount = (item) => {
    return Number(item.received_amount || item.final_price || item.price || 0);
  };
  const openWorkDetails = (work) => {
    navigate("/work-details", {
      state: {
        work,
      },
    });
  };
  const DESIGN_TYPES = ["Multi", "Sequence", "Cording", "Beads"];

  const getDesignTypes = (description = "") => {
    const lowerDescription = String(description).toLowerCase();

    return DESIGN_TYPES.filter((type) =>
      lowerDescription.includes(type.toLowerCase()),
    );
  };

  const removeDesignTypesFromDescription = (description = "") => {
    let cleanDescription = String(description);

    DESIGN_TYPES.forEach((type) => {
      const regex = new RegExp(`\\b${type}\\b\\s*,?\\s*`, "gi");
      cleanDescription = cleanDescription.replace(regex, "");
    });

    return cleanDescription
      .replace(/,\s*,/g, ",")
      .replace(/^,\s*|\s*,$/g, "")
      .trim();
  };
  const getRating = (item) => {
    const rating = Number(item.rating || 0);

    if (rating <= 0) {
      return 0;
    }

    return Math.min(5, Math.max(0, rating));
  };
  const canDeleteRejectedBid = (item) => {
    if (
      !item ||
      String(item.status || "")
        .trim()
        .toLowerCase() !== "rejected"
    ) {
      return false;
    }

    const workId = Number(item.work_id);

    const workBids = allWorkBids[workId] || [];

    const allowedStatuses = [
      "in progress",
      "completed",
      "work in review",
      "paid",
    ];

    return workBids.some((bid) => {
      const differentBid = Number(bid.id) !== Number(item.id);

      const status = String(bid.status || "")
        .trim()
        .toLowerCase();

      return differentBid && allowedStatuses.includes(status);
    });
  };
  return (
    <div className={`eb-mb-wrapper theme-${theme}`}>
      {/* Header Banner */}
      <div className="eb-mb-header">
        <div>
          <h2 className="eb-mb-title text-start">Designer Work Desk</h2>

          <p className="eb-mb-subtitle">
            Track project bids, manage active assignments, and view payout
            reports.
          </p>
        </div>

        {/* Designer Rating - Top Right */}
        <div className="eb-designer-rating">
          <div className="eb-rating-label">
            <i className="bi bi-star-fill"></i>
            My Rating
          </div>

          <div className="eb-rating-value">
            <strong>{designerRating.toFixed(1)}</strong>

            <div className="eb-rating-stars">
              {[1, 2, 3, 4, 5].map((star) => {
                if (designerRating >= star) {
                  return <i key={star} className="bi bi-star-fill"></i>;
                }

                if (designerRating >= star - 0.5) {
                  return <i key={star} className="bi bi-star-half"></i>;
                }

                return <i key={star} className="bi bi-star"></i>;
              })}
            </div>

            <span
              className="ms-2"
              style={{ fontSize: "13px", fontWeight: "600" }}
            >
              Total {designerRatingCount} Complated Work
            </span>
          </div>
        </div>
      </div>

      {/* Main Navigation Tabs */}
      <div className="eb-main-tabs-container">
        <div className="eb-main-tabs">
          <button
            className={`eb-tab-btn ${activeTab === "bids" ? "active" : ""}`}
            onClick={() => setActiveTab("bids")}
          >
            <i className="bi bi-briefcase-fill me-2"></i>
            My Bids
            <span className="eb-tab-badge">{stats.totalBids}</span>
          </button>
          <button
            className={`eb-tab-btn ${activeTab === "payments" ? "active" : ""}`}
            onClick={() => setActiveTab("payments")}
          >
            <i className="bi bi-wallet2 me-2"></i>
            Payment History
            <span className="eb-tab-badge">{filteredPayments.length}</span>
          </button>
        </div>
      </div>

      {/* Global Date Filter Component */}
      <div className="eb-date-card">
        <div>
          <h5>
            <i className="bi bi-calendar-range"></i>
            Filter Records
          </h5>
          <p>Select date range to refine bids and payment reports</p>
        </div>

        <DateFilter
          fromDate={fromDate}
          toDate={toDate}
          setFromDate={setFromDate}
          setToDate={setToDate}
        />
      </div>

      {/* TAB 1: Bids & Assignments */}
      {activeTab === "bids" && (
        <>
          <div className="eb-mb-finance-report">
            <div className="finance-header">
              <i className="bi bi-cash-stack me-2"></i> Completed Work Earnings
            </div>
            <div className="finance-grid">
              <div className="finance-card paid">
                <span className="finance-title">Total Received</span>
                <span className="finance-value">
                  ₹ {paymentSummary.totalPayment.toLocaleString()}
                </span>
                <span className="finance-subtitle">
                  {paymentSummary.totalPaid} Transaction(s)
                </span>
              </div>
              <div className="finance-card unpaid">
                <span className="finance-title">Pending Payment</span>
                <span className="finance-value">
                  ₹ {stats.unpaidAmount.toLocaleString()}
                </span>
                <span className="finance-subtitle">
                  {stats.unpaidCount} Project(s) Awaiting Payout
                </span>
              </div>
            </div>
          </div>
          {/* Primary Status Summary */}
          <div className="eb-mb-stats-grid">
            <div className="eb-mb-stat-card stat-total">
              <div className="stat-icon">
                <i className="bi bi-folder2-open"></i>
              </div>
              <div className="stat-info">
                <span className="stat-num">{stats.totalBids}</span>
                <span className="stat-label">Total Bids</span>
              </div>
            </div>

            <div className="eb-mb-stat-card stat-pending">
              <div className="stat-icon">
                <i className="bi bi-hourglass-split"></i>
              </div>
              <div className="stat-info">
                <span className="stat-num">{stats.pending}</span>
                <span className="stat-label">Pending Approval</span>
              </div>
            </div>

            <div className="eb-mb-stat-card stat-progress">
              <div className="stat-icon">
                <i className="bi bi-gear-wide-connected"></i>
              </div>
              <div className="stat-info">
                <span className="stat-num">{stats.inProgress}</span>
                <span className="stat-label">In Progress</span>
              </div>
            </div>

            <div className="eb-mb-stat-card stat-completed">
              <div className="stat-icon">
                <i className="bi bi-check-circle-fill"></i>
              </div>
              <div className="stat-info">
                <span className="stat-num">{stats.completed}</span>
                <span className="stat-label">Completed Works</span>
              </div>
            </div>
          </div>

          {/* Status Filter Bar */}
          <div className="eb-status-filter-bar mb-4">
            <div className="d-flex align-items-center gap-2 flex-wrap">
              <span className="fw-semibold text-muted small me-2">
                <i className="bi bi-funnel-fill me-1"></i> Status:
              </span>
              {statusList.map((status) => {
                const statusClass = status
                  .toLowerCase()
                  .trim()
                  .replace(/\s+/g, "-");

                return (
                  <button
                    key={status}
                    type="button"
                    className={`status-filter-btn status-${statusClass} ${
                      selectedStatus === status ? "active" : ""
                    }`}
                    onClick={() => setSelectedStatus(status)}
                  >
                    {status}
                  </button>
                );
              })}
            </div>
          </div>

          {/* Bids Main Grid */}
          {loading ? (
            <div className="eb-mb-loading">
              <div className="eb-mb-spinner"></div>
              <p>Fetching your bids dashboard...</p>
            </div>
          ) : filteredBeads.length > 0 ? (
            <div className="eb-mb-grid">
              {filteredBeads.map((item) => {
                const statusKey = (item.status || "")
                  .toLowerCase()
                  .replace(/\s+/g, "-");

                const statusInfo = getStatusInfo(item.status);

                const isCompleted = item.status === "Completed";

                const isPaid =
                  item.payment_status === "Paid" ||
                  item.is_paid === 1 ||
                  item.is_paid === "1";
                const designTypes = getDesignTypes(item.description);

                const cleanDescription = removeDesignTypesFromDescription(
                  item.description || "",
                );
                return (
                  <div className="eb-mb-card" key={item.id}>
                    {/* Media Section */}
                    <div
                      className="eb-mb-card-media"
                      onClick={() => {
                        const status = String(item.status || "")
                          .trim()
                          .toLowerCase();

                        if (status === "cancelled" || status === "rejected") {
                          return;
                        }

                        openWorkDetails(item);
                      }}
                      style={{
                        cursor:
                          String(item.status || "")
                            .trim()
                            .toLowerCase() === "cancelled" ||
                          String(item.status || "")
                            .trim()
                            .toLowerCase() === "rejected"
                            ? "default"
                            : "pointer",
                      }}
                    >
                      <div className="eb-mb-card-rating">
                        <div className="eb-mb-rating-stars">
                          {[1, 2, 3, 4, 5].map((star) => (
                            <i
                              key={star}
                              className={
                                star <= Number(item.rating || 0)
                                  ? "bi bi-star-fill"
                                  : "bi bi-star"
                              }
                            ></i>
                          ))}
                        </div>

                        <strong>{Number(item.rating || 0).toFixed(1)}</strong>
                      </div>
                      <span className={`eb-mb-badge badge-${statusKey}`}>
                        {item.status}
                      </span>

                      {item.images && item.images.length > 0 ? (
                        <div className="eb-mb-media-wrapper">
                          <img
                            src={`${UPLOADS.WORK_IMAGE}/${item.owner_id}/${item.images[0]}`}
                            alt="Work Preview"
                            className="eb-mb-thumb"
                            onClick={() =>
                              openLightbox(item.images, 0, item.owner_id)
                            }
                          />
                          {item.images.length > 1 && (
                            <div className="eb-image-count-overlay">
                              <i className="bi bi-images"></i>
                              <span>+{item.images.length}</span>
                            </div>
                          )}
                          {/* {item.images.length > 1 && (
                            <span className="eb-mb-count-tag">
                              +{item.images.length - 1}
                            </span>
                          )} */}
                          {item.status === "In Progress" ||
                            (item.status === "Start Work" && (
                              <button
                                className="eb-mb-count-tag"
                                onClick={() => downloadFiles(item)}
                              >
                                <i className="bi bi-download me-1"></i>
                                Download Image
                              </button>
                            ))}
                          <button
                            type="button"
                            className="eb-mb-zoom-btn"
                            onClick={() =>
                              openLightbox(item.images, 0, item.owner_id)
                            }
                            title="Expand Preview"
                          >
                            <i className="bi bi-arrows-angle-expand"></i>
                          </button>
                        </div>
                      ) : (
                        <div className="eb-mb-no-media">
                          <i className="bi bi-image"></i>
                          <span>No Media</span>
                        </div>
                      )}
                    </div>

                    {/* Card Content */}
                    <div className="eb-mb-card-body">
                      <div className="eb-mb-meta-row">
                        <span className="eb-mb-date">
                          <i className="bi bi-calendar3 me-1"></i>

                          {item.created_at
                            ? new Date(item.created_at).toLocaleDateString(
                                "en-GB",
                                {
                                  day: "2-digit",
                                  month: "short",
                                  year: "numeric",
                                },
                              )
                            : "-"}
                        </span>
                        <span
                          className="eb-mb-price eb-price-clickable"
                          onClick={() => openPriceDetails(item)}
                          title="Click to view payment details"
                        >
                          {/* ₹{Number(getAcceptedPrice(item)).toLocaleString()}   */}
                          ₹{Number(getRecievedAmount(item)).toLocaleString()}
                          {/* <i className="bi bi-info-circle ms-1"></i> */}
                        </span>
                      </div>

                      {designTypes.length > 0 && (
                        <div className="eb-design-type-list">
                          {designTypes.map((type) => (
                            <span
                              key={type}
                              className={`eb-design-type-badge eb-design-type-${type
                                .toLowerCase()
                                .replace(/\s/g, "")}`}
                            >
                              <i className="bi bi-check-circle-fill"></i>
                              {type}
                            </span>
                          ))}
                        </div>
                      )}

                      <div
                        className={`eb-status-message status-message-${statusKey}`}
                        // onClick={() => openStatusDetails(item)}
                      >
                        <div className="eb-status-message-icon">
                          <i className={`bi ${statusInfo.icon}`}></i>
                        </div>

                        <div className="eb-status-message-content">
                          <strong>{statusInfo.title}</strong>
                          {/* <p>{statusInfo.message}</p> */}
                        </div>

                        {/* <i className="bi bi-chevron-right eb-status-message-arrow"></i> */}
                      </div>
                      {isCompleted && (
                        <div className="eb-mb-payment-tag-row">
                          <span
                            className={`eb-pay-badge ${isPaid ? "pay-completed" : "pay-pending"}`}
                          >
                            <i
                              className={`bi ${isPaid ? "bi-check-all" : "bi-clock-history"}`}
                            ></i>
                            {isPaid ? "Payment Received" : "Payment Pending"}
                          </span>
                        </div>
                      )}

                      <div className="eb-mb-card-footer">
                        {item.status === "Pending" && (
                          <>
                            <button
                              className="eb-mb-btn btn-warning"
                              onClick={() => editBid(item)}
                            >
                              <i className="bi bi-pencil-square me-1"></i>
                              Edit
                            </button>

                            <button
                              className="eb-mb-btn btn-danger-soft"
                              onClick={() => deleteBeads(item.id)}
                            >
                              <i className="bi bi-trash3 me-1"></i>
                              Delete
                            </button>
                          </>
                        )}
                        {item.status === "Cancelled" && (
                          <>
                            <button
                              className="eb-mb-btn btn-danger-soft"
                              onClick={() => deleteBeads(item.id)}
                            >
                              <i className="bi bi-trash3 me-1"></i>
                              Delete
                            </button>
                          </>
                        )}
                        {item.status === "Rejected" &&
                          canDeleteRejectedBid(item) && (
                            <button
                              className="eb-mb-btn btn-danger-soft"
                              onClick={() => deleteBeads(item.id)}
                            >
                              <i className="bi bi-trash3 me-1"></i>
                              Delete
                            </button>
                          )}
                        {/* ACCEPTED - DESIGNER CAN CANCEL */}
                        {item.status === "Accepted" && (
                          <button
                            className="eb-mb-btn btn-danger-soft"
                            onClick={() => cancelAcceptedBid(item)}
                          >
                            <i className="bi bi-x-circle me-1"></i>
                            Cancel Bid
                          </button>
                        )}

                        {item.status === "Start Work" && (
                          <button
                            className="eb-mb-btn btn-primary"
                            onClick={() => startWork(item.id)}
                          >
                            <i className="bi bi-play-fill me-1"></i>
                            Start Work
                          </button>
                        )}

                        {item.status === "In Progress" && (
                          <button
                            className="eb-mb-btn btn-success"
                            onClick={() => {
                              setSelectedWork(item);
                              setShowSendModal(true);
                            }}
                          >
                            <i className="bi bi-send-fill me-1"></i>
                            Send Work
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          ) : (
            <div className="eb-mb-empty">
              <i className="bi bi-folder-x eb-mb-empty-icon"></i>
              <h4>No Bids Found</h4>
              <p>
                No bid requests match your filter selection. Try selecting a
                different status or date range.
              </p>
            </div>
          )}
        </>
      )}

      {/* TAB 2: Payment History */}
      {activeTab === "payments" && (
        <div className="eb-payment-tab-content">
          {/* Completed Work Financial Report Card */}
          <div className="eb-mb-finance-report">
            <div className="finance-header">
              <i className="bi bi-cash-stack me-2"></i> Completed Work Earnings
            </div>
            <div className="finance-grid">
              <div className="finance-card paid">
                <span className="finance-title">Total Received</span>
                <span className="finance-value">
                  ₹ {paymentSummary.totalPayment.toLocaleString()}
                </span>
                <span className="finance-subtitle">
                  {paymentSummary.totalPaid} Transaction(s)
                </span>
              </div>
              <div className="finance-card unpaid">
                <span className="finance-title">Pending Payment</span>
                <span className="finance-value">
                  ₹ {stats.unpaidAmount.toLocaleString()}
                </span>
                <span className="finance-subtitle">
                  {stats.unpaidCount} Project(s) Awaiting Payout
                </span>
              </div>
            </div>
          </div>

          {/* Payment History Data Table */}
          <div className="eb-payment-table-card">
            <div className="table-responsive mb-0">
              <table className="table eb-custom-table">
                <thead>
                  <tr className="text-center">
                    <th>#</th>
                    <th>Date</th>
                    <th>Amount</th>
                    <th>Payment Mode</th>
                    <th>Transaction No</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredPayments.length > 0 ? (
                    filteredPayments.map((p, index) => (
                      <tr key={p.id || index}>
                        <td> {filteredPayments.length - index}</td>
                        <td className="fw-medium">{p.payment_date}</td>
                        <td className="text-success fw-bold">
                          ₹ {Number(p.amount).toLocaleString()}
                        </td>
                        <td>
                          <span className="eb-mode-badge">
                            {p.payment_mode}
                          </span>
                        </td>
                        <td className="font-monospace text-muted small">
                          {p.transaction_no || ""}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="6" className="eb-table-empty">
                        <i className="bi bi-receipt-cutoff me-2"></i> No Payment
                        Records Found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}

      {/* Lightbox Modal */}
      {/* {lightboxData && (
        <div
          className="eb-mb-modal-overlay"
          onClick={() => setLightboxData(null)}
        >
          <div
            className="eb-mb-lightbox-box"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="eb-mb-lightbox-close"
              onClick={() => setLightboxData(null)}
            >
              &times;
            </button>
            <img
              src={lightboxData.images[lightboxData.currentIndex]}
              alt={`Preview ${lightboxData.currentIndex + 1}`}
              className="eb-mb-lightbox-img"
            />
            {lightboxData.images.length > 1 && (
              <>
                <button
                  className="eb-mb-arrow arrow-left"
                  onClick={handlePrevImage}
                >
                  <i className="bi bi-chevron-left"></i>
                </button>
                <button
                  className="eb-mb-arrow arrow-right"
                  onClick={handleNextImage}
                >
                  <i className="bi bi-chevron-right"></i>
                </button>
                <div className="eb-mb-lightbox-counter">
                  {lightboxData.currentIndex + 1} / {lightboxData.images.length}
                </div>
              </>
            )}
          </div>
        </div>
      )} */}

      {/* Upload/Send Work Modal */}
      {showSendModal && (
        <div className="eb-mb-modal-overlay">
          <div className="eb-mb-send-modal">
            <div className="eb-mb-modal-header">
              <h5>Submit Completed Work</h5>
              <button
                type="button"
                className="btn-close"
                onClick={() => setShowSendModal(false)}
              ></button>
            </div>

            <div className="eb-mb-modal-body">
              {/* <label className="form-label text-muted small fw-bold">
                Message for Client
              </label>
              <textarea
                className="form-control mb-3"
                rows="3"
                placeholder="Include design details, formats included, or notes..."
                value={message}
                onChange={(e) => setMessage(e.target.value)}
              /> */}

              <label className="form-label text-muted small fw-bold">
                Upload File
              </label>
              <input
                type="file"
                multiple
                accept=".emb,.dst,.pes,.jef,.zip,image/*,.pdf"
                className="form-control"
                onChange={(e) => setFiles([...e.target.files])}
              />
              <span className="form-text text-muted small">
                Supported formats: .emb, .zip, .rar
              </span>
            </div>

            <div className="eb-mb-modal-footer">
              <button
                className="btn btn-secondary btn-sm"
                onClick={() => setShowSendModal(false)}
                disabled={isSubmitting}
              >
                Cancel
              </button>
              <button
                className="btn btn-success btn-sm"
                onClick={sendCompletedWork}
                disabled={isSubmitting}
              >
                {isSubmitting ? "Submitting..." : "Send Work"}
              </button>
            </div>
          </div>
        </div>
      )}
      {showDescriptionModal && (
        <div
          className="eb-mb-modal-overlay"
          onClick={() => setShowDescriptionModal(false)}
        >
          <div
            className="eb-mb-send-modal"
            style={{ maxWidth: "700px" }}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="eb-mb-modal-header">
              <h5>Work Description</h5>

              <button
                type="button"
                className="btn-close"
                onClick={() => setShowDescriptionModal(false)}
              ></button>
            </div>

            <div className="eb-mb-modal-body">
              <p
                style={{
                  whiteSpace: "pre-wrap",
                  lineHeight: "1.8",
                  fontSize: "15px",
                  marginBottom: 0,
                }}
              >
                {selectedDescription}
              </p>
            </div>

            <div className="eb-mb-modal-footer">
              <button
                className="btn btn-secondary btn-sm"
                onClick={() => setShowDescriptionModal(false)}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
      {showEditModal && (
        <div
          className="eb-modal-backdrop"
          onClick={() => setShowEditModal(false)}
        >
          <div className="eb-modal-card" onClick={(e) => e.stopPropagation()}>
            <div className="eb-modal-header">
              <h5>Edit Bid Price</h5>

              <button
                className="eb-modal-close-btn"
                onClick={() => setShowEditModal(false)}
              >
                &times;
              </button>
            </div>

            <form onSubmit={updateBidPrice}>
              <div className="eb-modal-body">
                <label>Bid Price (₹)</label>

                <input
                  type="number"
                  className="form-control"
                  value={priceInput}
                  onChange={(e) => setPriceInput(e.target.value)}
                  min="1"
                  required
                />
              </div>
              <div
                style={{
                  marginTop: 20,
                  background: "#f8f9fa",
                  border: "1px solid #ddd",
                  borderRadius: 8,
                  padding: 15,
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginBottom: 8,
                  }}
                >
                  <span>Your Bid</span>
                  <strong>₹ {bidPrice.toFixed(2)}</strong>
                </div>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginBottom: 8,
                    color: "#dc3545",
                  }}
                >
                  <span>Platform Commission ({commission}%)</span>
                  <strong>- ₹ {commissionAmount.toFixed(2)}</strong>
                </div>

                <hr />

                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    fontSize: 18,
                  }}
                >
                  <span>You Will Receive</span>
                  <strong style={{ color: "#198754" }}>
                    ₹ {finalAmount.toFixed(2)}
                  </strong>
                </div>
              </div>

              <div className="eb-modal-footer">
                <button
                  type="button"
                  className="eb-btn-secondary"
                  onClick={() => setShowEditModal(false)}
                >
                  Cancel
                </button>

                <button
                  type="submit"
                  className="eb-btn-primary"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Updating..." : "Update Bid"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
      {/* Status Details Modal */}
      {showStatusModal &&
        selectedStatusBid &&
        (() => {
          const statusInfo = getStatusInfo(selectedStatusBid.status);

          return (
            <div
              className="eb-mb-modal-overlay"
              onClick={() => setShowStatusModal(false)}
            >
              <div
                className="eb-status-modal"
                onClick={(e) => e.stopPropagation()}
              >
                <div className="eb-status-modal-header">
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setShowStatusModal(false)}
                  ></button>
                </div>

                <div className="eb-status-modal-body">
                  <div
                    className={`eb-status-modal-icon status-icon-${(
                      selectedStatusBid.status || ""
                    )
                      .toLowerCase()
                      .replace(/\s+/g, "-")}`}
                  >
                    <i className={`bi ${statusInfo.icon}`}></i>
                  </div>

                  <h4>{statusInfo.title}</h4>

                  <span className="eb-status-current-badge">
                    Current Status: {selectedStatusBid.status}
                  </span>

                  <p>{statusInfo.message}</p>

                  {/* Show additional message according to status */}
                  {selectedStatusBid.status === "Pending" && (
                    <div className="eb-status-extra">
                      <i className="bi bi-info-circle"></i>
                      You can still edit or delete your bid until it is
                      reviewed.
                    </div>
                  )}

                  {selectedStatusBid.status === "Rejected" && (
                    <div className="eb-status-extra">
                      <i className="bi bi-lightbulb"></i>
                      Don't worry! You can apply for other available work
                      requests.
                    </div>
                  )}

                  {selectedStatusBid.status === "Accepted" && (
                    <div className="eb-status-extra">
                      <i className="bi bi-check-circle"></i>
                      Your bid has been approved successfully. Please wait for
                      the project to move to the next stage.
                    </div>
                  )}

                  {selectedStatusBid.status === "Start Work" && (
                    <div className="eb-status-extra">
                      <i className="bi bi-play-circle"></i>
                      You can now start working on this project.
                    </div>
                  )}

                  {selectedStatusBid.status === "In Progress" && (
                    <div className="eb-status-extra">
                      <i className="bi bi-upload"></i>
                      Complete the assigned work and submit your final files
                      when ready.
                    </div>
                  )}

                  {selectedStatusBid.status === "Work in Review" && (
                    <div className="eb-status-extra">
                      <i className="bi bi-eye"></i>
                      Your submitted work is currently being reviewed by the
                      client.
                    </div>
                  )}

                  {selectedStatusBid.status === "Completed" && (
                    <div className="eb-status-extra">
                      <i className="bi bi-check2-all"></i>
                      The project has been completed successfully.
                    </div>
                  )}

                  {selectedStatusBid.status === "Paid" && (
                    <div className="eb-status-extra">
                      <i className="bi bi-wallet2"></i>
                      Your payment has been successfully processed and recorded.
                    </div>
                  )}

                  <button
                    className="eb-status-got-it-btn"
                    onClick={() => setShowStatusModal(false)}
                  >
                    Got It
                  </button>
                </div>
              </div>
            </div>
          );
        })()}
      {/* Price Details Modal */}
      {showPriceModal &&
        selectedPriceBid &&
        (() => {
          const acceptedPrice = getAcceptedPrice(selectedPriceBid);

          const commissionPercent = Number(
            selectedPriceBid.commission_ratio || commission || 0,
          );

          const commissionAmount =
            selectedPriceBid.commission_amount !== null &&
            selectedPriceBid.commission_amount !== undefined
              ? Number(selectedPriceBid.commission_amount)
              : (acceptedPrice * commissionPercent) / 100;

          const receivedAmount =
            selectedPriceBid.received_amount !== null &&
            selectedPriceBid.received_amount !== undefined
              ? Number(selectedPriceBid.received_amount)
              : acceptedPrice - commissionAmount;

          return (
            <div
              className="eb-mb-modal-overlay"
              onClick={() => setShowPriceModal(false)}
            >
              <div
                className="eb-price-modal"
                onClick={(e) => e.stopPropagation()}
              >
                <div className="eb-price-modal-header">
                  <div>
                    <h5>
                      <i className="bi bi-cash-stack me-2"></i>
                      Bid Payment Details
                    </h5>
                    <small>Accepted bid amount breakdown</small>
                  </div>

                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setShowPriceModal(false)}
                  ></button>
                </div>

                <div className="eb-price-modal-body">
                  <div className="eb-simple-price-row">
                    <span>Your Bid Price</span>
                    <strong>₹ {acceptedPrice.toLocaleString()}</strong>
                  </div>

                  <div className="eb-simple-price-row">
                    <span>Commission ({commissionPercent}%)</span>
                    <strong className="text-danger">
                      - ₹ {commissionAmount.toLocaleString()}
                    </strong>
                  </div>

                  <div className="eb-simple-price-row eb-received-row">
                    <span>You Received</span>
                    <strong className="text-success">
                      ₹ {receivedAmount.toLocaleString()}
                    </strong>
                  </div>
                </div>
              </div>
            </div>
          );
        })()}
    </div>
  );
}
